import config from '_config';

function generateGridText(table, rows, columns) {
  const grid = Array.from({ length: rows }, () => Array(columns).fill(' '));

  if (!Array.isArray(table)) {
    return grid.map(row => row.join('')).join('\r\n');
  }

  table.forEach(cell => {
    const row = Number(cell.positionx);
    const col = Number(cell.positiony);

    const rowIsInvalid = Number.isNaN(row) || row < 0 || row >= rows;
    const colIsInvalid = Number.isNaN(col) || col < 0 || col >= columns;

    if (rowIsInvalid || colIsInvalid) {
      return;
    }

    const char = cell.text
      ? cell.text.charAt(0).toLocaleUpperCase(config.LOCALE)
      : ' ';
    grid[row][col] = char;
  });

  return grid.map(row => row.join('')).join('\r\n');
}

export default generateGridText;
